import { createAsyncThunk } from '@reduxjs/toolkit'
import toCamel from 'lodash-humps'
import { throwErrorForErrorResponse, errorHandler } from '../common'
import type { ErrorPayload } from '../common/error/errorAPI'

type ThunkConfig = {
  state: { common: { baseUri: string } }
  rejectValue: ErrorPayload
}

type FetchLayoutResultParams = {
  dataName?: string
}

export const fetchLayoutResult = createAsyncThunk<unknown, FetchLayoutResultParams, ThunkConfig>(
  'layoutDebug/fetchLayoutResult',
  async (params, { getState, rejectWithValue }) => {
    const { baseUri } = getState().common
    const queryParams = new URLSearchParams()
    if (params.dataName !== undefined) {
      queryParams.set('data_name', params.dataName)
    }
    const path = `${baseUri}layout_debug/layout_result` + (queryParams.size > 0 ? `?${queryParams}` : '')
    return fetch(path, {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(throwErrorForErrorResponse)
      .then((response) => response.json())
      .then(toCamel)
      .catch(errorHandler(rejectWithValue))
  }
)
